<h1 class="sr-only">Mappa del patrimonio</h1>

<div class="map-container" [class.hidden]="viewMode() === 'list'" [class.search-drawer-open]="searchDrawerOpen()" [class.search-panel-collapsed]="searchPanelCollapsed()">
  <div id="map" role="application" aria-label="Mappa interattiva delle collezioni digitali"></div>

  <div class="map-overlay">
    <div class="container">

      <!-- Filter panel (map mode) -->
      <div class="filter-panel-host mt-3">

      <!-- Ricarica mappa: speculare al pulsante di apertura filtri -->
      @if (showReloadMapButton()) {
        <div class="map-recenter-host">
          <dpac-button
            classe="custom-button-icon-md secondary"
            [icon]="recenterIcon"
            tooltip="Ricarica mappa"
            (onClick)="recenterMap()"
          />
        </div>
      }

      <div class="filter-panel filter-panel--collapsed" [class.filter-panel--inactive]="!searchPanelCollapsed()">
          <dpac-button
            classe="custom-button-icon-md primary"
            [icon]="searchOpenIcon"
            tooltip="Apri ricerca e filtri"
            (onClick)="toggleSearchPanel()"
          />
      </div>

      <div class="filter-panel" [class.filter-panel--inactive]="searchPanelCollapsed()" [class.drawer-open]="searchDrawerOpen()" [class.scrolled]="isNavbarScrolled()">

        <div class="flex items-center gap-2">
          <dpac-button
            classe="custom-button-icon-md tiertiary"
            [icon]="searchCloseIcon"
            [tooltip]="mobileFiltersOpen() ? 'Riduci filtri' : 'Riduci barra di ricerca'"
            (onClick)="onSearchPanelBackClick()"
          />

          <div class="min-w-0 grow">
            <dpac-search #mapSearch placeholder="Cerca" size="md"
              [enableSuggestions]="true"
              [initialValue]="searchBarValue()"
              [suggestions]="searchSuggestions()"
              suggestionLabelPrefix="Collezione:"
              suggestionSublabelPrefix="Ente:"
              [suggestionsLoading]="searchSuggestionsLoading()"
              [suggestionsQuery]="searchSuggestionsQuery()"
              (search)="onSearchTypeahead($event)"
              (searchFocus)="onSearchFocus($event)"
              (searchCommit)="onSearchCommit($event)"
              (suggestionSelect)="onSearchSuggestionSelect($event)" />
          </div>

          <!-- Toggle mappa/lista: non ancora in uso -->
          <!-- <div class="view-toggle-box">
            <dpac-button
              classe="custom-button-icon-sm"
              [class.active]="viewMode() === 'map'"
              [icon]="mapIcon"
              (onClick)="switchToMapView()"
            />
            <dpac-button
              classe="custom-button-icon-sm"
              [class.active]="viewMode() === 'list'"
              [icon]="listIcon"
              (onClick)="switchToListView()"
            />
          </div> -->

        </div>

        @if (!mobileFiltersOpen()) {
          <button
            type="button"
            class="filter-filtri-btn"
            (click)="mobileFiltersOpen.set(true)"
            aria-expanded="false"
          >
            Filtri
          </button>
        }

        <div class="flex flex-wrap items-center gap-2 filter-selects-row mt-4 w-full" [class.filter-selects-hidden]="!mobileFiltersOpen()" [formGroup]="filterForm">

          <div class="flex flex-wrap items-center gap-2 filter-selects-group">
            <dpac-select
              [multiple]="true"
              [countBadge]="true"
              [size]="'md'"
              [options]="tipologiaBeneOptions()"
              optionLabel="descrizione"
              optionValue="id"
              placeholder="Tipologia beni"
              formControlName="tipologiaBene"
            />
            <dpac-select
              [multiple]="true"
              [countBadge]="true"
              [options]="tipologiaRisoraOptions()"
              [size]="'md'"
              optionLabel="descrizione"
              optionValue="id"
              placeholder="Tipologia risorse"
              formControlName="tipologiaRisorsa"
            />
          </div>

          <div class="flex items-center gap-2 filter-actions-group">
            <dpac-checkbox label="Accessibili Online" formControlName="accessibiliOnline" />

            @if (hasActiveFilters()) {
              <dpac-button
                classe="bare-link custom-button-md text-[var(--btn-primary-bg-base-color)]"
                (onClick)="resetFilters()">
                Azzera filtri
              </dpac-button>
            }
          </div>
        </div>

      </div>
      </div>
    </div>
  </div>

</div>

<!-- ═══ LIST VIEW ═══ -->
@if (viewMode() === 'list') {
  <div class="list-view-container">
    <div class="list-view-content">

      <!-- Filter panel (list mode) -->
      <div class="list-filter-panel">
        <div class="flex items-center gap-2">
          <div class="grow">
            <dpac-search placeholder="Cerca per Titolo Collezione / Ente / ..." size="md"
              [initialValue]="searchBarValue()"
              (search)="onSearchInput($event)" />
          </div>

          <!-- Mobile only: toggle filtri -->
          <button
            type="button"
            class="mobile-filter-toggle"
            (click)="mobileFiltersOpen.set(!mobileFiltersOpen())"
            [class.mobile-filter-toggle--active]="mobileFiltersOpen()"
            [attr.aria-expanded]="mobileFiltersOpen()"
            aria-label="Mostra/nascondi filtri"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="4" y1="6" x2="20" y2="6"/>
              <line x1="8" y1="12" x2="16" y2="12"/>
              <line x1="11" y1="18" x2="13" y2="18"/>
            </svg>
          </button>

          <div class="view-toggle-box">
            <dpac-button
              classe="custom-button-icon-sm"
              [class.active]="viewMode() === 'map'"
              [icon]="mapIcon"
              (onClick)="switchToMapView()"
            />
            <dpac-button
              classe="custom-button-icon-sm"
              [class.active]="viewMode() === 'list'"
              [icon]="listIcon"
              (onClick)="switchToListView()"
            />
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-2 filter-selects-row mt-4 w-full" [class.filter-selects-hidden]="!mobileFiltersOpen()" [formGroup]="filterForm">
          <div class="flex flex-wrap items-center gap-2 grow">
            <div class="flex flex-wrap items-center gap-2">
              <dpac-select
                [multiple]="true"
                [countBadge]="true"
                [size]="'lg'"
                [options]="tipologiaBeneOptions()"
                optionLabel="descrizione"
                optionValue="id"
                placeholder="Tipologia beni"
                formControlName="tipologiaBene"
              />

              <dpac-select
                [multiple]="true"
                [countBadge]="true"
                [options]="tipologiaRisoraOptions()"
                optionLabel="descrizione"
                optionValue="id"
                placeholder="Tipologia risorse"
                formControlName="tipologiaRisorsa"
              />

              <dpac-checkbox label="Accessibili Online" formControlName="accessibiliOnline" />
            </div>

            @if (hasActiveFilters()) {
              <div class="ml-auto">
                <dpac-button
                  classe="bare-link bg-[var(--btn-primary-bg-base-color)]"
                  (onClick)="resetFilters()">
                  Azzera filtri
                </dpac-button>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Collection list (table) to do -->
      <dpac-collection-list
        [items]="listItems()"
        [totalElements]="listTotalElements()"
        [currentPage]="listCurrentPage()"
        [totalPages]="listTotalPages()"
        [pageSize]="listPageSize()"
        [sortOrder]="listSortOrder()"
        (pageChange)="onListPageChange($event)"
        (sortChange)="onListSortChange($event)"
        (viewOnMap)="onViewOnMap($event)"
      />
    </div>
  </div>
}

<!-- Search Results Drawer -->
<dpac-drawer [isOpen]="searchDrawerOpen()" [hasHeader]="true" [topOffset]="navbarHeight()" (closed)="closeSearchDrawer()">

  <!-- Header fisso: contatore, ente e chiusura restano sempre visibili -->
  <div drawer-header class="drawer-header">
    <div class="drawer-header-top">
      @if (totalCollectionsCount() > 0) {
        <span class="drawer-pill">{{ visibleCollectionsCount() }} DI {{ totalCollectionsCount() }} COLLEZIONI</span>
        @if (hasHiddenCollections()) {
          <button
            type="button"
            class="drawer-show-all-btn"
            (click)="showAllCollections()"
            aria-label="Mostra tutte le collezioni"
          >
            Mostra tutte le collezioni
          </button>
        }
      }
      <button type="button" class="drawer-close-btn" aria-label="Chiudi elenco collezioni" (click)="closeSearchDrawer()">✕</button>
    </div>

    @if (selectedEnteTitle()) {
      <h2 class="drawer-ente-title">{{ selectedEnteTitle() }}</h2>
    }
  </div>

  <div drawer-body>


    @if (searchLoading() && totalCollectionsCount() === 0) {
      <div class="drawer-detail-loading" role="status" aria-live="polite" aria-label="Caricamento collezioni">
        <div class="drawer-detail-spinner" aria-hidden="true"></div>
      </div>
    } @else if (totalCollectionsCount() > 0) {
    <div class="flex flex-col gap-4">

      <!-- Riga 1: Indirizzo dell'ente -->
      @if (selectedCollection()?.indirizzo) {
        <a class="drawer-address-link">{{ selectedCollection()!.indirizzo }}</a>
      }

      <!-- Riga 2: Tipologie collezione (max 5 chip per gruppo) -->
      @if (drawerTipologiaBeneElements().length > 0 || drawerTipologiaRisorsaElements().length > 0) {
        <div class="drawer-chip-groups">
          @if (drawerTipologiaBeneElements().length > 0) {
            <div class="drawer-chip-group-row">
              <span class="drawer-chip-group-title">Tipologia bene:</span>
              <div class="drawer-chip-list" aria-label="Elenco tipologie bene">
                @for (item of drawerVisibleTipologiaBeneElements(); track item) {
                  <span class="drawer-static-chip">{{ item }}</span>
                }
                @if (drawerHasMoreTipologiaBene()) {
                  <button
                    type="button"
                    class="drawer-static-chip drawer-static-chip--more"
                    aria-label="Mostra tutti gli elementi"
                    (click)="toggleDrawerChips('tipologiaBene')"
                  >
                    ...
                  </button>
                }
                @if (showAllTipologiaBeneChips()) {
                  <button
                    type="button"
                    class="drawer-static-chip drawer-static-chip--more"
                    aria-label="Mostra meno elementi"
                    (click)="toggleDrawerChips('tipologiaBene')"
                  >
                    ‹ meno
                  </button>
                }
              </div>
            </div>
          }

          @if (drawerTipologiaRisorsaElements().length > 0) {
            <div class="drawer-chip-group-row mt-4">
              <span class="drawer-chip-group-title">Tipologia risorsa:</span>
              <div class="drawer-chip-list" aria-label="Elenco tipologie risorsa">
                @for (item of drawerVisibleTipologiaRisorsaElements(); track item) {
                  <span class="drawer-static-chip">{{ item }}</span>
                }
                @if (drawerHasMoreTipologiaRisorsa()) {
                  <button
                    type="button"
                    class="drawer-static-chip drawer-static-chip--more"
                    aria-label="Mostra tutti gli elementi"
                    (click)="toggleDrawerChips('tipologiaRisorsa')"
                  >
                    ...
                  </button>
                }
                @if (showAllTipologiaRisorsaChips()) {
                  <button
                    type="button"
                    class="drawer-static-chip drawer-static-chip--more"
                    aria-label="Mostra meno elementi"
                    (click)="toggleDrawerChips('tipologiaRisorsa')"
                  >
                    ‹ meno
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (visibleCollectionsCount() > 0) {
        <!-- Riga 3: Select per scegliere la collezione -->
        <div class="drawer-select-container">
          <dpac-select
            class="drawer-select"
            [class.drawer-select--single]="isSingleCollection()"
            [options]="searchResultsOptions()"
            optionLabel="descrizione"
            optionValue="id"
            placeholder="Seleziona collezione"
            [value]="selectedResultId()"
            [readonly]="isSingleCollection()"
            [disabled]="isSingleCollection()"
            (selectionChange)="onDrawerCollectionChange($event)" />
        </div>

        <!-- Divider -->
        <!-- <hr class="drawer-divider" /> -->

        <!-- Riga 4: Card dettaglio collezione selezionata -->
        @if (collectionDetailLoading()) {
          <div class="drawer-detail-loading" role="status" aria-live="polite" aria-label="Caricamento dettagli collezione">
            <div class="drawer-detail-spinner" aria-hidden="true"></div>
          </div>
        } @else if (selectedCollection(); as col) {
        <div class="drawer-detail-card">

        <!-- Image e Titolo -->
        <div class="flex items-start gap-3">
          @if (col.image) {
            <img [src]="col.image" [alt]="'Copertina della collezione ' + col.titolo" class="drawer-thumb">
          } @else {
            <div class="drawer-thumb drawer-thumb--placeholder" aria-hidden="true"></div>
          }
          <h4 class="drawer-card-title">{{ col.titolo }}</h4>
        </div>

        <!-- Descrizione -->
        @if (col.descrizione) {
          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Descrizione</span>
            <p class="drawer-description">{{ col.descrizione }}</p>
          </div>
        }

        <!-- Grid informazioni -->
        <div class="drawer-info-grid">

          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Proprietario collezione</span>
            <span class="drawer-field-value">{{ col.proprietario || 'N/A' }}</span>
          </div>

          <!-- <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Risorse Contenute</span>
            <span class="drawer-field-value">{{ col.risorseContenute ?? 0 }}</span>
          </div> -->

          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Tipologia bene</span>
            <span class="drawer-field-value">{{ formatTipologiaBene(col.tipologiaBene) }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Tipologia risorse</span>
            <span class="drawer-field-value">{{ formatTipologiaRisorse(col.tipologiaRisorse) }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Metadati</span>
            <span class="drawer-field-value">{{ col.metadati ? 'Descrittivi' : 'No' }}</span>
          </div>

          @if (col.licenza) {
          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Licenza</span>
            <span class="drawer-field-value">{{ col.licenza }}</span>
          </div>
          }

          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Accesso in loco</span>
            <span class="drawer-field-value">{{ col.accessoInLoco ? 'Sì' : 'No' }}</span>
          </div>

          @if (col.modalitaAccesso) {
          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Modalità di accesso</span>
            <span class="drawer-field-value">{{ col.modalitaAccesso }}</span>
          </div>
          }

        </div>
         <!-- note -->
        @if (col.note) {
          <div class="flex flex-col gap-1">
            <span class="drawer-field-label">Note</span>
            <p class="drawer-description">{{ col.note }}</p>
          </div>
        }
        <!-- link here  -->

        @if (col.url) {
          <div class="flex justify-end gap-1">
            <button class="flex items-center gap-1 text-purple-600 text-sm hover:underline"  (click)="openWebSite(col.url)">
              <span class="me-2">Vai al sito</span>
              <img  [src]="linkIcon.src" alt="Icona collegamento al sito web" width="16" height="16" style="filter: invert(29%) sepia(89%) saturate(1242%) hue-rotate(259deg) brightness(88%) contrast(101%);">
            </button>
          </div>
        }


        </div>
        }
      } @else {
        <div class="text-gray-500 text-center">
          <p>Nessuna collezione corrisponde ai filtri correnti</p>
        </div>
      }

    </div>
    } @else {
    <div class="text-gray-500 text-center">
      <p>Nessun risultato trovato</p>
    </div>
    }
  </div>
</dpac-drawer>
